// @ts-nocheck
import { useEffect, useState } from "react";

export function useDebounce<T>(value: T, delay = 500): UseDebounceReturn {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
